import axios from '../../axios/index.js'

export default {
  list(data) {
    return axios.get('recipients/list',{params:data})
  },
  store(data) {
    return axios.post('recipients',data)
  },
  update(data) {
    return axios.post('recipients/update',data)
  }
}
